export default __webpack_public_path__ + "portfolio.5e7495ee.png";